import * as URI from 'urijs';
import { MediaType, MediaDocument } from '../../media-document.model';
import { ICONOCLAST_URL } from '../content-document-adapter.config';

const extractAuthors = (document: any) => {
    const authors = document.authors;
    if (!authors) {
        return authors
    }

    const filteredAuthors = authors.filter( a => getAuthorName(a, document.sourceId));
    return filteredAuthors.map(a => {
        return {
            icmUrl: a.id ? `/icm-web/influencers/contact/view/${a.id}` : null,
            name: getAuthorName(a, document.sourceId),
        }
    });
}

const getAuthorName = (author: any, sourceId: string = null) => {
    if (author.authorInfo && author.authorInfo.structuredName && author.authorInfo.structuredName.firstName && author.authorInfo.structuredName.lastName) {
        const { prefix, firstName, middleName, lastName, suffix } = author.authorInfo.structuredName;
        return [prefix, firstName, middleName, lastName, suffix].filter(p => !!p).join(' ');
    } else if (sourceId && sourceId.indexOf('adhoc:') > -1 && (!author.authorInfo || !author.authorInfo.structuredName) && author.name) {
        return author.name;
    }
}

export class ContentDocumentNewsAdapter {

    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);

        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.authors = extractAuthors(document);
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.ingress = document.ingress;
        contentDocument.keywords = document.keywords || document.tagContextKeywords;
        contentDocument.matchSentences = [document.matchSentence || document.tagContextMatchSentence];
        contentDocument.mediaImageUrl = (document.images && document.images[0]) ? document.images[0].link : '';
        contentDocument.mediaType = MediaType.News;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarImgUrl = document.sourceUrl ? `${ICONOCLAST_URL}/favicon?size=48&url=${new URI(document.sourceUrl).origin()}` : '';
        // Overriding sourceAvatarImgUrl when provider = 'dowjones'
        contentDocument.sourceAvatarImgUrl = document.provider === 'dowjones' ? 'https://assets.meltwater.io/premium-content/dowjones.png' : contentDocument.sourceAvatarImgUrl;
        // Overriding sourceAvatarImgUrl when sourceUrl = 'www.weibo.com'
        contentDocument.sourceAvatarImgUrl = document.sourceUrl === 'www.weibo.com' ? '//app.meltwater.com/discovery/assets/custom_avatars/weibo-logo.png' : contentDocument.sourceAvatarImgUrl;
        // Overriding sourceAvatarImgUrl when sourceUrl = 'www.wechat.com'
        contentDocument.sourceAvatarImgUrl = document.sourceUrl === 'www.wechat.com' ? '//app.meltwater.com/discovery/assets/custom_avatars/wechat-logo.png' : contentDocument.sourceAvatarImgUrl;

        contentDocument.sourceAvatarLinkUrl = document.paywallUrl || document.redirectUrl || document.url || document.sourceUrl;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = document.source || 'Unknown';
        contentDocument.sourceNameUrl = document.paywallUrl || document.redirectUrl || document.sourceUrl || document.url;
        contentDocument.tags = document.tags;
        contentDocument.title = document.title;
        contentDocument.titleUrl = document.paywallUrl || document.redirectUrl || document.url || document.sourceUrl;
        contentDocument.language = document.language;

        // TODO: not sure if we need this, might be same as sourceUrl
        contentDocument.url = document.paywallUrl || document.redirectUrl || document.url || document.sourceUrl;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.reachCount = document.reach;
        contentDocument.reachUrl = this.getReachUrl(document.sourceUrl);
        contentDocument.socialScores = document.socialScores;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }

    private static getReachUrl(url) {
        if (!url) return null;

        // remove protocol, www and path to only have the hostname
        const noProtocolUrl = url.replace(/https?\:\/\/(www\.)?/, '').split('/')[0];
        return `https://www.similarweb.com/website/${noProtocolUrl}`;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-news.adapter.ts